import React, { useState } from 'react';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const PersonalInfoForm = ({ onNext, savedData }) => {
  const [formData, setFormData] = useState({
    fullName: savedData?.fullName || '',
    email: savedData?.email || '',
    phone: savedData?.phone || '',
    yearsOfPractice: savedData?.yearsOfPractice || ''
  });

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};

    if (!formData?.fullName?.trim()) {
      newErrors.fullName = 'Full name is required';
    }

    if (!formData?.email?.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/?.test(formData?.email)) {
      newErrors.email = 'Please enter a valid email address';
    }

    if (!formData?.phone?.trim()) {
      newErrors.phone = 'Phone number is required';
    }

    if (!formData?.yearsOfPractice || formData?.yearsOfPractice < 0) {
      newErrors.yearsOfPractice = 'Years of practice is required';
    }

    setErrors(newErrors);
    return Object.keys(newErrors)?.length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e?.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    if (validateForm()) {
      onNext(formData);
    }
  };

  return (
    <div className="space-y-4 sm:space-y-6">
      <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
        <div className="w-8 h-8 sm:w-10 sm:h-10 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
          <Icon name="User" size={18} className="sm:w-5 sm:h-5" color="var(--color-primary)" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-base sm:text-lg font-semibold text-foreground truncate">Personal Information</h3>
          <p className="text-xs sm:text-sm text-muted-foreground">Enter your basic details</p>
        </div>
      </div>

      <form onSubmit={handleSubmit} className="space-y-3 sm:space-y-4">
        <Input
          label="Full Name"
          name="fullName"
          type="text"
          value={formData?.fullName}
          onChange={handleChange}
          placeholder="Dr. John Smith"
          required
          error={errors?.fullName}
        />

        <Input
          label="Email Address"
          name="email"
          type="email"
          value={formData?.email}
          onChange={handleChange}
          placeholder="john.smith@hospital.com"
          required
          error={errors?.email}
        />

        <Input
          label="Phone Number"
          name="phone"
          type="tel"
          value={formData?.phone}
          onChange={handleChange}
          placeholder="+1 (555) 123-4567"
          required
          error={errors?.phone}
        />

        <Input
          label="Years of Practice"
          name="yearsOfPractice"
          type="number"
          value={formData?.yearsOfPractice}
          onChange={handleChange}
          placeholder="e.g., 5"
          required
          min="0"
          max="60"
          error={errors?.yearsOfPractice}
          helpText="Enter the total number of years you have been practicing medicine"
        />
      </form>
    </div>
  );
};

export default PersonalInfoForm;